export default "__VITE_ASSET__D_23XMPP__"